import { useEffect } from 'libs/react';
import { useRef } from 'libs/react';
import { React } from 'libs/react';
import './Radio.scss';
/**
 * @component Radio
 * @since 1.0.0
 * @hidden
 */
export function Radio(props) {
    let { type, name, ident, value, outer, checked, required, disabled } = Object.assign({ type: 'radio', checked: false }, props);
    const node = useRef(null);
    /**
     * @function getOthers
     * @since 1.0.0
     * @hidden
     */
    function getOthers() {
        return Array.from(document.getElementsByName(name)).filter((input) => input != node.current);
    }
    /**
     * @function onInputBlur
     * @since 1.0.0
     * @hidden
     */
    function onInputBlur() {
        if (props.onBlur) {
            props.onBlur();
        }
    }
    /**
     * @function onInputFocus
     * @since 1.0.0
     * @hidden
     */
    function onInputFocus() {
        if (props.onFocus) {
            props.onFocus();
        }
    }
    /**
     * @function onInputClick
     * @since 1.0.0
     * @hidden
     */
    function onInputClick(e) {
        e.stopPropagation();
    }
    /**
     * @function onInputChange
     * @since 1.0.0
     * @hidden
     */
    function onInputChange(e) {
        getOthers().forEach((input) => {
            input.dispatchEvent(new Event('update'));
        });
        if (props.onChange) {
            props.onChange(e.currentTarget.checked);
        }
    }
    /**
     * @function onInputUpdate
     * @since 1.0.0
     * @hidden
     */
    function onInputUpdate(e) {
        if (props.onChange) {
            props.onChange(e.currentTarget.checked);
        }
    }
    /**
     * @function onOuterClick
     * @since 1.0.0
     * @hidden
     */
    function onOuterClick() {
        const input = node.current;
        if (input == null) {
            return;
        }
        if (input.checked == false) {
            input.checked = true;
            getOthers().forEach((input) => {
                input.dispatchEvent(new Event('update'));
            });
            if (props.onChange) {
                props.onChange(true);
            }
        }
    }
    useEffect(() => {
        if (outer.current) {
            outer.current.addEventListener('click', onOuterClick);
        }
        return () => {
            if (outer.current) {
                outer.current.removeEventListener('click', onOuterClick);
            }
        };
    }, []);
    useEffect(() => {
        if (node.current) {
            node.current.addEventListener('update', onInputUpdate);
        }
        return () => {
            if (node.current) {
                node.current.removeEventListener('update', onInputUpdate);
            }
        };
    }, []);
    if (value == null) {
        value = '';
    }
    return (React.createElement("input", { id: ident, ref: node, type: type, name: name, value: value, checked: checked, required: required, disabled: disabled, onBlur: onInputBlur, onFocus: onInputFocus, onClick: onInputClick, onChange: onInputChange }));
}
